import {AuthenticationDetails, CognitoUser, CognitoUserPool} from 'amazon-cognito-identity-js'
import { push } from 'svelte-spa-router'
import { get } from 'svelte/store'
import { gotCode, isLogged, user } from '../store'
import config from './config'

export default class CognitoAuth {

    constructor () {
        this.userPool = new CognitoUserPool({ UserPoolId: config.UserPoolId, ClientId: config.ClientId })
        this.populateUser()
    }

    populateUser() {
        this.getSession()
            .then(({ idToken: {
                jwtToken: token,
                payload: { 'cognito:username': username }
            }}) => user.update(store => Object.assign(store,{ token, username })))
            .catch(_ => null)
    }

    authenticate(Username, Password, cb) {
        const authenticationDetails = new AuthenticationDetails({ Username, Password })
        const cognitoUser = new CognitoUser({ Username, Pool: this.userPool })
        cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: result => {
                    this.populateUser()
                    cb(null, result)
                },
                onFailure: err => {
                    if (err.code === 'PasswordResetRequiredException') {
                        gotCode.set(true)
                        push('/forgotPassword')
                    }
                    cb(err)
                },
                newPasswordRequired: userAttributes => push('/newPassword')
            }
        )
    }

    async passwordChallange (Username, newPassword) {
        const { password: Password } = get(user)
        const authenticationDetails = new AuthenticationDetails({ Username, Password })
        const cognitoUser = new CognitoUser({ Username, Pool: this.userPool })

        new Promise((resolve, reject) => {
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: resolve,
                onFailure: reject,
                newPasswordRequired: (userAttributes, requiredAttributes) => {
                    delete userAttributes['email_verified']
                    cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, {
                        onSuccess: resolve,
                        onFailure: reject
                    })
                }
            })
        })
    }

    async isAuthenticated () {
        return this.getSession()
            .then(session => {
                const isValid = session?.isValid()
                isLogged.set(isValid || false)
                return get(isLogged)
            })
    }

    getCurrentUser () {
        return this.userPool.getCurrentUser()
    }

    logout() {
        if (this.getCurrentUser()) this.getCurrentUser().signOut()

        user.update(store => (store.token = null, store))
        isLogged.set(false)
        push('/login')
    }

    async getSession() {
        return this.getCurrentUser()?.getSession((err, session) => {
            if (err) return err
            return session
        })
    }

    async sendVerificationCode() {
        const { username: Username } = get(user)
        const cognitoUser = new CognitoUser({ Username, Pool: this.userPool })

        return new Promise((resolve, reject) =>
            cognitoUser.forgotPassword({ onSuccess: resolve, onFailure: reject })
        )
    }

    async confirmRecovery() {
        const { username: Username, newPassword, verifyCode } = get(user)
        const cognitoUser = new CognitoUser({ Username, Pool: this.userPool })

        return new Promise((resolve, reject) =>
            cognitoUser.confirmPassword(verifyCode, newPassword, { onSuccess: resolve, onFailure: reject })
        )
    }

}
